// The same shape the browser's type="email" check uses: something, an @,
// something with a dot. It rejects blanks and obvious typos before a request
// is spent; the server's binding is the real validator.
const emailShape = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function IsValidEmail(email: string): boolean {
    return emailShape.test(email.trim());
}
